// src/App.tsx
import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { IdleTimeoutProvider, SessionProvider } from "./lib/session";
import { FacilityAccessProvider } from "./lib/FacilityAccessContext";
import { NotificationCenterProvider } from "./features/notifications/NotificationCenter";
import { useOfflineConfigPrefetch } from "./features/offline/config/prefetch";
import { useOfflineConfigWarmup } from "./features/offline/config/warmup";
import { OfflineCacheStatusProvider } from "./features/offline/state/OfflineCacheStatusContext";
import { OfflineCachePolicyProvider } from "./features/offline/state/OfflineCachePolicyProvider";
import { OfflineWarmupStatusProvider } from "./features/offline/state/OfflineWarmupStatusContext";
import { OfflineCacheProgressOverlay } from "./features/offline/components/OfflineCacheProgressOverlay";
import { WarmupToast } from "./features/offline/components/WarmupToast";

const PublicTravellerDeclaration = React.lazy(() => import("./pages/traveller/thdf/PublicTravellerDeclaration"));

export default function App() {
  // Public entry point intentionally mounts outside staff sessions, notifications and offline providers.
  if (window.location.pathname.replace(/\/$/, "") === "/traveller-declaration") {
    return <React.Suspense fallback={<p className="p-6">Loading declaration…</p>}><PublicTravellerDeclaration /></React.Suspense>;
  }
  return <StaffApp />;
}

function StaffApp() {
  return (
    <SessionProvider>
      <IdleTimeoutProvider>
        <OfflineCachePolicyProvider>
          <OfflineWarmupStatusProvider>
            <OfflineCacheStatusProvider>
              <AppContent />
            </OfflineCacheStatusProvider>
          </OfflineWarmupStatusProvider>
        </OfflineCachePolicyProvider>
      </IdleTimeoutProvider>
    </SessionProvider>
  );
}

function AppContent() {
  useOfflineConfigPrefetch();
  useOfflineConfigWarmup();

  return (
    <FacilityAccessProvider>
      <NotificationCenterProvider>
        <BrowserRouter>
          <AppRoutes />
          <OfflineCacheProgressOverlay />
          <WarmupToast />
        </BrowserRouter>
      </NotificationCenterProvider>
    </FacilityAccessProvider>
  );
}
